import { render } from "./RegisterMerchant.vue?vue&type=template&id=0f21160b"
import script from "./RegisterMerchant.vue?vue&type=script&lang=js"
export * from "./RegisterMerchant.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__